import { ActionIcon, ActionIconProps, Menu, Stack, useMantineTheme } from '@mantine/core'
import { IconDotsVertical } from '@tabler/icons-react'
import React, { useState } from 'react'

import classes from './OptionsMenu.module.css'

export type GeneralOptionsMenuLink = {
  label: string
  action?: () => void
}

interface GeneralOptionsMenuProps extends ActionIconProps {
  links: GeneralOptionsMenuLink[]
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  vertical?: boolean
}

const GeneralOptionsMenu: React.FC<GeneralOptionsMenuProps> = ({
  links,
  style,
  onClick,
  vertical = false,
}) => {
  const theme = useMantineTheme()
  const [hover, setHover] = useState<boolean>(false)
  const [opened, setOpened] = useState<boolean>(false)

  return (
    <div onClick={e => onClick?.(e)}>
      <Menu position="bottom-end" withArrow shadow="md" opened={opened} onChange={setOpened}>
        <Menu.Target>
          <ActionIcon
            className={classes.actionIcon}
            style={{ ...style }}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            <IconDotsVertical
              style={{
                rotate: vertical ? '0deg' : '90deg',
                color: hover ? theme.colors.background[0] : 'white',
              }}
            />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown className={classes.dropdown}>
          <Stack className={classes.menuItems}>
            {links.map(({ label, action }) => (
              <a
                key={label}
                onClick={e => {
                  e.stopPropagation()
                  action?.()
                  setOpened(false)
                }}
                className={classes.options}
              >
                {label}
              </a>
            ))}
          </Stack>
        </Menu.Dropdown>
      </Menu>
    </div>
  )
}

export default GeneralOptionsMenu
